// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-1JGYF";
var _4 = "buttonContainer-2oZ7i";
var _5 = "button-14Uay";
var _6 = "services-3AVqy";
var _7 = "cardItemContainer-31RgZ";
var _8 = "accompaniesDelimiter-3KZzT";
var _9 = "container_modal-1xGY9";
var _a = "header_modal-1qGgf";
var _b = "header__icon_modal-2ur5Q";
var _c = "message__text_modal-1Zpaq";
var _d = "footer_modal-3Uip1";
var _e = "button_modal-PEcqg";
var _f = "passenger-rtrPT";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "buttonContainer", _5 as "button", _6 as "services", _7 as "cardItemContainer", _8 as "accompaniesDelimiter", _9 as "container_modal", _a as "header_modal", _b as "header__icon_modal", _c as "message__text_modal", _d as "footer_modal", _e as "button_modal", _f as "passenger" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "buttonContainer": _4, "button": _5, "services": _6, "cardItemContainer": _7, "accompaniesDelimiter": _8, "container_modal": _9, "header_modal": _a, "header__icon_modal": _b, "message__text_modal": _c, "footer_modal": _d, "button_modal": _e, "passenger": _f }
